module.exports = __webpack_public_path__ + "img/bj1.8089f465.jpg";